import React, {useState, useEffect, useRef} from "react";
import {Link, usePage} from "@inertiajs/react";


function Header ({locale, menu}) {

    const [isOpenMenuMobile, setIsOpenMenuMobile] = useState(false);
    const { url } = usePage();

    const [isOpen, setIsOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);

        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    const languages = [
        { code: 'en', label: 'Eng' },
        { code: 'fr', label: 'Fr' },
        { code: 'de', label: 'De' },
    ];

    const currentLang = languages.find(lang => lang.code === locale);

    const handleLanguageChange = (languageCode) => {
        setIsOpen(false);

        let newUrl = '';
        const supportedLanguages = languages.map(lang => lang.code);

        // Use full URL from window.location to work with hashes
        const fullUrl = window.location.pathname + window.location.hash;
        const [pathname, hash] = fullUrl.split('#');
        const pathOnly = pathname;

        if (languageCode === 'en') {
            const languagePattern = supportedLanguages.filter(lang => lang !== 'en').join('|');
            const regex = new RegExp(`^/(${languagePattern})(/|$)`);

            if (regex.test(pathOnly)) {
                newUrl = pathOnly.replace(regex, (match, lang, slash) => {
                    return `/en${slash}`;
                });
            } else {
                newUrl = `/en${pathOnly}`;
            }
        } else {
            if (pathOnly === '/' || pathOnly === '') {
                newUrl = `/${languageCode}`;
            } else {
                const languagePattern = supportedLanguages.join('|');
                const regex = new RegExp(`^/(${languagePattern})(/|$)`);

                if (regex.test(pathOnly)) {
                    newUrl = pathOnly.replace(regex, `/${languageCode}$2`);
                } else {
                    newUrl = `/${languageCode}${pathOnly}`;
                }
            }
        }

        // Add hash back if it existed
        if (hash) {
            newUrl += `#${hash}`;
        }

        window.location.href = newUrl;
    };

    useEffect(() => {
        if (isMobile) return;

        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isMobile]);

    useEffect(() => {
        return () => {
            document.body.classList.remove('scroll-lock');
        };
    }, [url]);

    const toggleMenu = (isOpen) => {
        const status = isOpen === undefined ? isOpenMenuMobile : !isOpen;
        if (status) {
            document.body.classList.remove('scroll-lock');
            setIsOpenMenuMobile(false);
        } else {
            document.body.classList.add('scroll-lock');
            setIsOpenMenuMobile(true);
        }
    };

    return (
        <header className={'header container'}>
            <div className={'header__inner container__inner'}>
                <div className={'header__logo'}>
                    <Link href={locale === 'en' ? '/' : `/${locale}`}>
                        <img src={require('@images/layout/header/logo.svg').default} alt="logo" />
                    </Link>
                </div>

                <nav className={`header__menu ${isOpenMenuMobile ? 'is-on' : ''}`}>
                    <ul className={'header__menu-list'}>
                        {menu.map(item => {
                            const isAnchor = item.url.split("/").length === 1 && item.url.indexOf("#") !== -1;
                            const isActive = !isAnchor && item.url !== '' && (
                                url === item.url || url.startsWith(item.url + '/')
                            );

                            return (
                                <li key={item.id} className={isActive ? "is-active" : ""}>
                                    {
                                        isAnchor
                                            ?
                                            // anchor link with language prefix
                                            <a href={`${locale === 'en' ? '/' : `/${locale}`}${item.url}`} onClick={() => toggleMenu(false)}><span>{item.title}</span></a>
                                            :
                                            // route link
                                            <Link href={item.url} onClick={() => toggleMenu(false)}><span>{item.title}</span></Link>
                                    }
                                </li>
                            )
                        })}
                    </ul>
                </nav>

                <div className={'header__lang-switcher'} ref={dropdownRef}>
                    {isMobile ? (
                        <div className="header__lang-mobile">
                            {languages.map((language, index) => (
                                <React.Fragment key={language.code}>
                                    <button
                                        type="button"
                                        className={`header__lang-mobile-item ${locale === language.code ? 'active' : ''}`}
                                        onMouseDown={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            handleLanguageChange(language.code);
                                        }}
                                    >
                                        {language.label}
                                    </button>
                                    {index < languages.length - 1 && <span>|</span>}
                                </React.Fragment>
                            ))}
                        </div>
                    ) : (
                        <>
                            <button
                                type="button"
                                className="header__lang-trigger"
                                onClick={() => setIsOpen(!isOpen)}
                            >
                                <span className="header__lang-name">{currentLang?.label || 'Eng'}</span>
                                <span className={`header__lang-arrow ${isOpen ? 'open' : ''}`}>
                                    <img src={require('@images/icon-arrow-down.svg').default} alt="icon" />
                                </span>
                            </button>
                            {isOpen && (
                                <div className="header__lang-dropdown">
                                    {languages.map((language) => (
                                        <button
                                            type="button"
                                            key={language.code}
                                            className={`language-option ${locale === language.code ? 'active' : ''}`}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                handleLanguageChange(language.code);
                                            }}
                                        >
                                            {language.label}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </>
                    )}
                </div>

                <button className={`header__btn-burger ${isOpenMenuMobile ? 'is-on' : ''}`} onClick={() => toggleMenu()}>
                    <span className={'header__btn-burger-item header__btn-burger-item-1'}></span>
                    <span className={'header__btn-burger-item header__btn-burger-item-2'}></span>
                    <span className={'header__btn-burger-item header__btn-burger-item-3'}></span>
                </button>


            </div>
        </header>
    );
}

export default Header;
